module.exports = __webpack_public_path__ + "static/icons/oops.a8d5365.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/characters/oops.svg
// module id = mHqF
// module chunks = 1